import { EmbeddedRecordsMixin } from '@ember-data/serializer/rest';
import type { ModelSchema } from '@ember-data/store/types';
import ApplicationSerializer from 'lumen/serializers/application';

interface TotalRevenueDashboardPayload {
  departments: {
    trend: {
      days: unknown[];
      months: unknown[];
      weeks: unknown[];
    };
    trendDays: unknown[];
    trendMonths: unknown[];
    trendWeeks: unknown[];
  }[];
}

// eslint-disable-next-line @typescript-eslint/no-unsafe-call
export default class TotalRevenueDashboardSerializer extends ApplicationSerializer.extend(
  EmbeddedRecordsMixin,
) {
  attrs = {
    summary: { embedded: 'always' },
    portfolio: { embedded: 'always' },
    departments: { embedded: 'always' },
  };

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  modelNameFromPayloadKey(key: string) {
    if (key === 'total_revenue_dashboard') {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-return
      return super.modelNameFromPayloadKey('total-revenue/dashboard');
    }

    // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-return
    return super.modelNameFromPayloadKey(key);
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  normalize(
    typeClass: ModelSchema,
    resourceHash: TotalRevenueDashboardPayload,
  ) {
    resourceHash.departments.forEach((department) => {
      department.trendDays = department.trend.days;
      department.trendWeeks = department.trend.weeks;
      department.trendMonths = department.trend.months;
    });

    // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-return
    return super.normalize(typeClass, resourceHash);
  }
}
